import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/tech-academy-apac/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Resources & Presentations`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://ibm.box.com/s/3x1k55q9fezqlv3fp270o0fgnfsvx6bp"
          }}>{`Session’s Presentations Box Folder`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/tech-academy-apac/gitops/"
          }}>{`GitOps Automation Framework Lab Handout`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/tech-academy-apac/end2end/eslab/"
          }}>{`End-to-end Event Streams Lab`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/tech-academy-apac/end2end/mqlab/"
          }}>{`End-to-end MQ Lab`}</a></p>
      </li>
    </ul>
    <hr></hr>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      